import { render, staticRenderFns } from "./PhotoDetails.vue?vue&type=template&id=2e6f76d8&scoped=true"
import script from "./PhotoDetails.vue?vue&type=script&lang=js"
export * from "./PhotoDetails.vue?vue&type=script&lang=js"
import style0 from "./PhotoDetails.vue?vue&type=style&index=0&id=2e6f76d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6f76d8",
  null
  
)

export default component.exports